// Code generated by protoc-gen-ts_proto. DO NOT EDIT.
// versions:
//   protoc-gen-ts_proto  v2.7.1
//   protoc               v4.23.4
// source: common/product_surface.proto

/* eslint-disable */
import type { AccessType, CfLocation } from "./common";

export interface ProductSurface {
  surfaceType: ProductSurface_SurfaceType;
  botId?: string | undefined;
  accessPassId?: string | undefined;
  appId?: string | undefined;
  experienceId?: string | undefined;
  accessType?: AccessType | undefined;
  planId?: string | undefined;
  profileUserId?: string | undefined;
  viewContext?: ProductSurface_ViewContext | undefined;
  discoverSection?: ProductSurface_DiscoverSection | undefined;
  universalPostId?: string | undefined;
  feedTab?: ProductSurface_FeedTab | undefined;
}

export const ProductSurface_ViewContext = {
  VIEW_CTX_UNKNOWN: "VIEW_CTX_UNKNOWN",
  /** VIEW_CTX_WHOP - / The user is viewing from inside a whop view. */
  VIEW_CTX_WHOP: "VIEW_CTX_WHOP",
  /** VIEW_CTX_HOME_FEED - / The user is viewing from the home feed */
  VIEW_CTX_HOME_FEED: "VIEW_CTX_HOME_FEED",
  UNRECOGNIZED: "UNRECOGNIZED",
} as const;

export type ProductSurface_ViewContext = typeof ProductSurface_ViewContext[keyof typeof ProductSurface_ViewContext];

export namespace ProductSurface_ViewContext {
  export type VIEW_CTX_UNKNOWN = typeof ProductSurface_ViewContext.VIEW_CTX_UNKNOWN;
  export type VIEW_CTX_WHOP = typeof ProductSurface_ViewContext.VIEW_CTX_WHOP;
  export type VIEW_CTX_HOME_FEED = typeof ProductSurface_ViewContext.VIEW_CTX_HOME_FEED;
  export type UNRECOGNIZED = typeof ProductSurface_ViewContext.UNRECOGNIZED;
}

export const ProductSurface_DiscoverSection = {
  DISCOVER_UNKNOWN: "DISCOVER_UNKNOWN",
  DISCOVER_LEADERBOARDS: "DISCOVER_LEADERBOARDS",
  DISCOVER_FOR_YOU: "DISCOVER_FOR_YOU",
  DISCOVER_EXPLORE: "DISCOVER_EXPLORE",
  UNRECOGNIZED: "UNRECOGNIZED",
} as const;

export type ProductSurface_DiscoverSection =
  typeof ProductSurface_DiscoverSection[keyof typeof ProductSurface_DiscoverSection];

export namespace ProductSurface_DiscoverSection {
  export type DISCOVER_UNKNOWN = typeof ProductSurface_DiscoverSection.DISCOVER_UNKNOWN;
  export type DISCOVER_LEADERBOARDS = typeof ProductSurface_DiscoverSection.DISCOVER_LEADERBOARDS;
  export type DISCOVER_FOR_YOU = typeof ProductSurface_DiscoverSection.DISCOVER_FOR_YOU;
  export type DISCOVER_EXPLORE = typeof ProductSurface_DiscoverSection.DISCOVER_EXPLORE;
  export type UNRECOGNIZED = typeof ProductSurface_DiscoverSection.UNRECOGNIZED;
}

export const ProductSurface_FeedTab = {
  FEED_TAB_UNKNOWN: "FEED_TAB_UNKNOWN",
  FEED_TAB_HOME: "FEED_TAB_HOME",
  FEED_TAB_EARN: "FEED_TAB_EARN",
  FEED_TAB_CHAT: "FEED_TAB_CHAT",
  FEED_TAB_LEARN: "FEED_TAB_LEARN",
  FEED_TAB_CALENDAR: "FEED_TAB_CALENDAR",
  FEED_TAB_PLAY: "FEED_TAB_PLAY",
  FEED_TAB_INTEGRATIONS: "FEED_TAB_INTEGRATIONS",
  FEED_TAB_TOOLS: "FEED_TAB_TOOLS",
  UNRECOGNIZED: "UNRECOGNIZED",
} as const;

export type ProductSurface_FeedTab = typeof ProductSurface_FeedTab[keyof typeof ProductSurface_FeedTab];

export namespace ProductSurface_FeedTab {
  export type FEED_TAB_UNKNOWN = typeof ProductSurface_FeedTab.FEED_TAB_UNKNOWN;
  export type FEED_TAB_HOME = typeof ProductSurface_FeedTab.FEED_TAB_HOME;
  export type FEED_TAB_EARN = typeof ProductSurface_FeedTab.FEED_TAB_EARN;
  export type FEED_TAB_CHAT = typeof ProductSurface_FeedTab.FEED_TAB_CHAT;
  export type FEED_TAB_LEARN = typeof ProductSurface_FeedTab.FEED_TAB_LEARN;
  export type FEED_TAB_CALENDAR = typeof ProductSurface_FeedTab.FEED_TAB_CALENDAR;
  export type FEED_TAB_PLAY = typeof ProductSurface_FeedTab.FEED_TAB_PLAY;
  export type FEED_TAB_INTEGRATIONS = typeof ProductSurface_FeedTab.FEED_TAB_INTEGRATIONS;
  export type FEED_TAB_TOOLS = typeof ProductSurface_FeedTab.FEED_TAB_TOOLS;
  export type UNRECOGNIZED = typeof ProductSurface_FeedTab.UNRECOGNIZED;
}

export const ProductSurface_SurfaceType = {
  UNKNOWN: "UNKNOWN",
  EXPERIENCE: "EXPERIENCE",
  WHOP: "WHOP",
  CREATOR_DASHBOARD: "CREATOR_DASHBOARD",
  AFFILIATE_DASHBOARD: "AFFILIATE_DASHBOARD",
  DISCOVER: "DISCOVER",
  HOME_FEED: "HOME_FEED",
  MESSAGES: "MESSAGES",
  PROFILE: "PROFILE",
  NOTIFICATIONS: "NOTIFICATIONS",
  USER_SETTINGS: "USER_SETTINGS",
  CHECKOUT: "CHECKOUT",
  AUTH: "AUTH",
  OTHER: "OTHER",
  USER_ONBOARDING: "USER_ONBOARDING",
  LEADERBOARD: "LEADERBOARD",
  UNRECOGNIZED: "UNRECOGNIZED",
} as const;

export type ProductSurface_SurfaceType = typeof ProductSurface_SurfaceType[keyof typeof ProductSurface_SurfaceType];

export namespace ProductSurface_SurfaceType {
  export type UNKNOWN = typeof ProductSurface_SurfaceType.UNKNOWN;
  export type EXPERIENCE = typeof ProductSurface_SurfaceType.EXPERIENCE;
  export type WHOP = typeof ProductSurface_SurfaceType.WHOP;
  export type CREATOR_DASHBOARD = typeof ProductSurface_SurfaceType.CREATOR_DASHBOARD;
  export type AFFILIATE_DASHBOARD = typeof ProductSurface_SurfaceType.AFFILIATE_DASHBOARD;
  export type DISCOVER = typeof ProductSurface_SurfaceType.DISCOVER;
  export type HOME_FEED = typeof ProductSurface_SurfaceType.HOME_FEED;
  export type MESSAGES = typeof ProductSurface_SurfaceType.MESSAGES;
  export type PROFILE = typeof ProductSurface_SurfaceType.PROFILE;
  export type NOTIFICATIONS = typeof ProductSurface_SurfaceType.NOTIFICATIONS;
  export type USER_SETTINGS = typeof ProductSurface_SurfaceType.USER_SETTINGS;
  export type CHECKOUT = typeof ProductSurface_SurfaceType.CHECKOUT;
  export type AUTH = typeof ProductSurface_SurfaceType.AUTH;
  export type OTHER = typeof ProductSurface_SurfaceType.OTHER;
  export type USER_ONBOARDING = typeof ProductSurface_SurfaceType.USER_ONBOARDING;
  export type LEADERBOARD = typeof ProductSurface_SurfaceType.LEADERBOARD;
  export type UNRECOGNIZED = typeof ProductSurface_SurfaceType.UNRECOGNIZED;
}

export interface ProductSurfaceUpdate {
  productSurface: ProductSurface | undefined;
  isAppForegrounded: boolean;
  /** The current url or screen that the user is on - used for debugging "other" screen views. */
  currentUrl?: string | undefined;
}

export interface ActiveUserBucket {
  userBucketType: ActiveUserBucket_UserBucketType;
  id?: string | undefined;
}

export const ActiveUserBucket_UserBucketType = {
  UNKNOWN: "UNKNOWN",
  EXPERIENCE: "EXPERIENCE",
  WHOP: "WHOP",
  STORE_PAGE: "STORE_PAGE",
  MESSAGES: "MESSAGES",
  HOME_FEED: "HOME_FEED",
  DISCOVER: "DISCOVER",
  BOT: "BOT",
  UNRECOGNIZED: "UNRECOGNIZED",
} as const;

export type ActiveUserBucket_UserBucketType =
  typeof ActiveUserBucket_UserBucketType[keyof typeof ActiveUserBucket_UserBucketType];

export namespace ActiveUserBucket_UserBucketType {
  export type UNKNOWN = typeof ActiveUserBucket_UserBucketType.UNKNOWN;
  export type EXPERIENCE = typeof ActiveUserBucket_UserBucketType.EXPERIENCE;
  export type WHOP = typeof ActiveUserBucket_UserBucketType.WHOP;
  export type STORE_PAGE = typeof ActiveUserBucket_UserBucketType.STORE_PAGE;
  export type MESSAGES = typeof ActiveUserBucket_UserBucketType.MESSAGES;
  export type HOME_FEED = typeof ActiveUserBucket_UserBucketType.HOME_FEED;
  export type DISCOVER = typeof ActiveUserBucket_UserBucketType.DISCOVER;
  export type BOT = typeof ActiveUserBucket_UserBucketType.BOT;
  export type UNRECOGNIZED = typeof ActiveUserBucket_UserBucketType.UNRECOGNIZED;
}

export interface ActiveUsersInBucket {
  activeUserBucket:
    | ActiveUserBucket
    | undefined;
  /** / The number of users in the bucket. Always set to the total number of users in the bucket. */
  userCount: number;
  /** / The list of user ids that joined the bucket. Sent only on realtime pushes */
  joinedUsers: ActiveUsersInBucket_UserData[];
  /** / The list of user ids that left the bucket. Sent only on realtime pushes */
  leftUsers: ActiveUsersInBucket_UserData[];
  /** / The list of user ids in the bucket. Only populated if requested by the backend. */
  users: ActiveUsersInBucket_UserData[];
  /** / The offset used when making the request */
  offset?:
    | number
    | undefined;
  /** / The limit used when making the request */
  limit?: number | undefined;
}

export interface ActiveUsersInBucket_UserData {
  userId: string;
  cfLocation?: CfLocation | undefined;
}

export interface GetUserLastSeenAtBatchRequest {
  userIds: string[];
}

export interface GetUserLastSeenAtBatchResponse {
  usersLastSeenAt: { [key: string]: GetUserLastSeenAtBatchResponse_UserLastSeenAtResponse };
}

export interface GetUserLastSeenAtBatchResponse_UserLastSeenAtResponse {
  lastSeenAt: string | undefined;
}

export interface GetUserLastSeenAtBatchResponse_UsersLastSeenAtEntry {
  key: string;
  value: GetUserLastSeenAtBatchResponse_UserLastSeenAtResponse | undefined;
}

export interface GetActiveUsersInBucketBatchRequest {
  requests: GetActiveUsersInBucketBatchRequest_Request[];
}

export interface GetActiveUsersInBucketBatchRequest_Request {
  activeUserBucket:
    | ActiveUserBucket
    | undefined;
  /** / Whether to include the user ids in the response. */
  includeUserIds: boolean;
  /** / The maximum number of user ids to return. MAX=5000. Ordering = lexicographic by user_id */
  limit: number;
  /** / The offset used when making the request. */
  offset: number;
}

export interface GetActiveUsersInBucketBatchResponse {
  activeUsersInBuckets: ActiveUsersInBucket[];
}

export interface GetUserProductSurfacesBatchRequest {
  userIds: string[];
}

export interface GetUserProductSurfacesBatchResponse {
  /**
   * / This returns a single product surface per user for simplicity.
   * / If they are currently active on multiple devices, this may change rapidly.
   * / If they are active on multiple devices, but only a single device is foregrounded,
   * / that device's product surface will be prioritized.
   */
  userProductSurfaces: { [key: string]: GetUserProductSurfacesBatchResponse_ProductSurfaceState };
}

export interface GetUserProductSurfacesBatchResponse_ProductSurfaceState {
  productSurface: ProductSurface | undefined;
  isAppForegrounded: boolean;
  lastUpdatedAt: string | undefined;
  firstSeenAt: string | undefined;
}

export interface GetUserProductSurfacesBatchResponse_UserProductSurfacesEntry {
  key: string;
  value: GetUserProductSurfacesBatchResponse_ProductSurfaceState | undefined;
}

export interface GetTopExperiencesByActiveUsersRequest {
  limit?: number | undefined;
  appFilter?: GetTopExperiencesByActiveUsersRequest_AppFilter | undefined;
}

export const GetTopExperiencesByActiveUsersRequest_AppFilter = {
  ALL: "ALL",
  LIVESTREAMS: "LIVESTREAMS",
  UNRECOGNIZED: "UNRECOGNIZED",
} as const;

export type GetTopExperiencesByActiveUsersRequest_AppFilter =
  typeof GetTopExperiencesByActiveUsersRequest_AppFilter[keyof typeof GetTopExperiencesByActiveUsersRequest_AppFilter];

export namespace GetTopExperiencesByActiveUsersRequest_AppFilter {
  export type ALL = typeof GetTopExperiencesByActiveUsersRequest_AppFilter.ALL;
  export type LIVESTREAMS = typeof GetTopExperiencesByActiveUsersRequest_AppFilter.LIVESTREAMS;
  export type UNRECOGNIZED = typeof GetTopExperiencesByActiveUsersRequest_AppFilter.UNRECOGNIZED;
}

export interface GetTopExperiencesByActiveUsersResponse {
  experienceItems: GetTopExperiencesByActiveUsersResponse_ExperienceItem[];
}

export interface GetTopExperiencesByActiveUsersResponse_ExperienceItem {
  experienceId: string;
  activeUserCount: number;
}

export interface UserPresenceService {
  GetUserLastSeenAtBatch(request: GetUserLastSeenAtBatchRequest): Promise<GetUserLastSeenAtBatchResponse>;
  /** / Fetch a list of active users in a bucket, and their count. */
  GetActiveUsersInBucketBatch(
    request: GetActiveUsersInBucketBatchRequest,
  ): Promise<GetActiveUsersInBucketBatchResponse>;
  /** / Fetch where and when a user was last active. */
  GetUserProductSurfacesBatch(
    request: GetUserProductSurfacesBatchRequest,
  ): Promise<GetUserProductSurfacesBatchResponse>;
  /** Fetch the experience ids with the most amount of active users. */
  GetTopExperiencesByActiveUsers(
    request: GetTopExperiencesByActiveUsersRequest,
  ): Promise<GetTopExperiencesByActiveUsersResponse>;
}
